import axios from "axios";

// Production defaults to same-origin. This keeps the frontend independent
// from the public domain so moving the site later does not require a rebuild.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;
export const asset = (u) => {
  if (!u) return "";
  if (u.startsWith("http") || u.startsWith("data:")) return u;
  return `${BACKEND_URL}${u}`;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ozalp_token");
  const p = localStorage.getItem("ozalp_portal");
  if (config.url && config.url.includes("/portal/") && p) {
    config.headers.Authorization = `Bearer ${p}`;
  } else if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function apiError(e, fallback = "Bir şeyler ters gitti. Lütfen tekrar deneyin.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}
